import { withFormsy, propTypes } from "formsy-react";
import { MdFileUpload } from "react-icons/md";
import { GiCancel } from "react-icons/gi";
import React from "react";
import { Row, Col, FormGroup, FormFeedback, Label, Input, Button, FormText, Card, CardBody, UncontrolledAlert } from "reactstrap";
import { Spinner } from "../Shared/Spinner";
class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAnyMessage: true,
            correctMessage: false,
            isWrongFileSize: false,
            imageName: null,
            imagePreviewUrl: null,
            isWrongFileFormat: false,
            editedImageChange: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isImageUpLoaded) {
            this.props.setValue(this.state.imagePreviewUrl);
            this.props.cancelImageUploadingSetting();
        }
    }
    formatFileType = (fileType) => {
        if (fileType && fileType.length) {
            const acceptedTypes = fileType.join("|");
            return `/.(${acceptedTypes})$/i`;
        }
        return null;
    };

    checkEditedImageChange = () => {
        return this.state.editedImageChange;
    };

    changeValue = (event) => {
        if (this.props.editedPostId) {
            this.setState({ editedImageChange: true });
        }

        event.preventDefault();
        let acceptedFormats;
        if (this.props.imageUrl) {
            this.props.setImageNull();
        }

        if (this.props.acceptedFormats) {
            acceptedFormats = this.props.acceptedFormats ? this.props.acceptedFormats.replace(",", "|") : "jpg|jpeg|png|gif";
        }

        let regMatcher = new RegExp(`.(${acceptedFormats})$`, "i");

        let reader = new FileReader();
        let files = event.target.files;
        let file = files[0];

        if (files && files.length > 0) {
            reader.readAsDataURL(file);
            if (file.name.match(regMatcher)) {
                if (file.size <= this.props.maxSize) {
                    reader.onloadend = () => {
                        this.setState({
                            imagePreviewUrl: reader.result,
                            imageName: file.name,
                            isWrongFileFormat: false,
                            isWrongFileSize: false,
                            correctMessage: true,
                        });

                        if (this.props.uploadToServer) {
                            this.props.uploadingToCloud(this.state.imagePreviewUrl);
                        } else {
                            this.props.setValue(this.state.imagePreviewUrl);
                        }
                    };
                } else {
                    this.setState({
                        isWrongFileFormat: false,
                        correctMessage: false,
                        isWrongFileSize: true,
                    });
                }
            } else {
                this.setState({
                    isWrongFileFormat: true,
                    correctMessage: false,
                    isWrongFileSize: false,
                });
            }
        }
    };
    resetValue = (event) => {
        event.target.value = null;
    };
    cancelImage = () => {
        if (this.props.uploadToServer) {
            this.props.cancelUploadedImageUrl();
        } else if (this.props.imageUrl) {
            this.props.setImageNull();
        }
        // to handle image uploaded to the cloud.

        this.setState(
            {
                showAnyMessage: true,
                correctMessage: false,
                isWrongFileSize: false,
                imageName: null,
                imagePreviewUrl: null,
                isWrongFileFormat: false,
            },
            () => {
                this.props.resetValue();
            }
        );
    };

    toDataURL = (url, callback) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
    };

    render() {
        const errorMessage = this.props.getErrorMessage();
        const { showAnyMessage, correctMessage, isWrongFileFormat, isWrongFileSize, imageName, imagePreviewUrl } = this.state;

        const { showRequired, showError, isPristine, isRequired, className, name, hasValue, title, infoText, showLoader, imageUrl, dontShowCancelButton, isView, isUpLoading, imageUploadError, submitting } = this.props;

        const hasError = !isPristine() && (showError() || (isRequired() && !hasValue()));

        return (
            <FormGroup className={className}>
                {title && (
                    <Label className={isRequired() && "required"} htmlFor={name}>
                        {title}
                    </Label>
                )}

                {isView ? null : (
                    <Row>
                        <Col className="mb-2">
                            <div className="file-input-wrapper">
                                <Button className="btn-file-input" color="primary" size="sm">
                                    {" "}
                                    <MdFileUpload size={20} /> Choose Image
                                </Button>
                                <Input
                                    type="file"
                                    name="file"
                                    //disabled={true}
                                    onChange={this.changeValue}
                                    onClick={this.resetValue}
                                />
                            </div>
                            {showAnyMessage && correctMessage && !isUpLoading ? (
                                <label style={{ position: "initial" }}>{imageName}</label>
                            ) : showAnyMessage && isWrongFileSize ? (
                                <label
                                    style={{
                                        position: "initial",
                                        color: "red",
                                    }}
                                >
                                    Max file size: 1mb. File is too large.
                                </label>
                            ) : showAnyMessage && isWrongFileFormat ? (
                                <label
                                    style={{
                                        position: "initial",
                                        color: "red",
                                    }}
                                >
                                    File extension not supported.
                                </label>
                            ) : (
                                <label
                                    style={{
                                        position: "initial",
                                    }}
                                >
                                    {isView ? null : `Only ${this.props.acceptedFormats || ".jpg,.jpeg,.png"} files are allowed.`}
                                </label>
                            )}
                        </Col>
                    </Row>
                )}

                {correctMessage || imageUrl ? (
                    <div>
                        {imageUploadError && !imageUploadError.errors ? (
                            <UncontrolledAlert color="danger" style={{ width: "48%" }}>
                                {imageUploadError.message}
                            </UncontrolledAlert>
                        ) : null}
                        {imageUploadError && imageUploadError.errors && imageUploadError.errors.length ? (
                            <UncontrolledAlert color="danger">
                                {imageUploadError.errors.map((error, index) => (
                                    <p key={index}>{error.message}</p>
                                ))}
                            </UncontrolledAlert>
                        ) : null}
                        <Card
                            style={{
                                marginTop: "1rem",
                                width: "auto",
                                display: "inline-block",
                                backgroundColor: isUpLoading ? "whitesmoke" : "none",
                                marginLeft: isUpLoading ? "2rem" : "none",
                            }}
                        >
                          
                            {!isUpLoading ? (
                                <Row>
                                    <Col>
                                        <CardBody>
                                            <img src={imageUrl ? imageUrl : imagePreviewUrl} width="200" alt="" />
                                        </CardBody>
                                    </Col>
                                    {dontShowCancelButton && imageUrl ? null : (
                                        <Button
                                            style={{
                                                borderRadius: "50%",
                                                position: "absolute",
                                                top: "-0.6rem",
                                                right: "-0.8rem",
                                                padding: "1px",
                                            }}
                                            color="danger"
                                            onClick={this.cancelImage}
                                        >
                                            <GiCancel size={30} />
                                        </Button>
                                    )}
                                </Row>
                            ) : submitting ? (
                                <Col>
                                    <CardBody style={{ paddingLeft: "2rem" }}>
                                        <Spinner style={{ width: "64px", height: "64px" }} />
                                    </CardBody>
                                </Col>
                            ) : null}
                        </Card>
                    </div>
                ) : null}

                {infoText ? <FormText>{infoText}</FormText> : ""}
                {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
                {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
                {showLoader ? <Spinner /> : ""}
            </FormGroup>
        );
    }
}

FileUpload.propTypes = {
    ...propTypes,
};
const filesUpLoad = withFormsy(FileUpload);
export { filesUpLoad as UploadFile };
